export const REDUCER_NAME = 'detail';


// WEBPACK FOOTER //
// ./src/modules/partner/state/detail/const.js